import {
  addObj,
  getAll,
  searchByName,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
  getMyAll,
  getMyPage,
  bindmonitoredareaTomonitoredareaGroup
} from '@/api/monitoredareaserv'

export default {
  state: {
    state_MonitoredArea_AddObjResult: null,
    state_MonitoredArea_GetAllResult: null,
    state_MonitoredArea_SearchByNameResult: null,
    state_MonitoredArea_GetPageResult: null,
    state_MonitoredArea_GetDetailResult: null,
    state_MonitoredArea_ModifyObjResult: null,
    state_MonitoredArea_DeleteObjResult: null,
    state_MonitoredArea_GetMyAllResult: null,
    state_MonitoredArea_GetMyPageResult: null,
    state_MonitoredArea_BindmonitoredareaTomonitoredareaGroupResult: null
  },
  mutations: {
    SET_MONITOREDAREA_ADDOBJ_RESULT: (state, rst) => {
      state.state_MonitoredArea_AddObjResult = rst
    },
    SET_MONITOREDAREA_GETALL_RESULT: (state, rst) => {
      state.state_MonitoredArea_GetAllResult = rst
    },
    SET_MONITOREDAREA_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_MonitoredArea_SearchByNameResult = rst
    },
    SET_MONITOREDAREA_GETPAGE_RESULT: (state, rst) => {
      state.state_MonitoredArea_GetPageResult = rst
    },
    SET_MONITOREDAREA_GETDETAIL_RESULT: (state, rst) => {
      state.state_MonitoredArea_GetDetailResult = rst
    },
    SET_MONITOREDAREA_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_MonitoredArea_ModifyObjResult = rst
    },
    SET_MONITOREDAREA_DELETEOBJ_RESULT: (state, rst) => {
      state.state_MonitoredArea_DeleteObjResult = rst
    },
    SET_MONITOREDAREA_GETMYALL_RESULT: (state, rst) => {
      state.state_MonitoredArea_GetMyAllResult = rst
    },
    SET_MONITOREDAREA_GETMYPAGE_RESULT: (state, rst) => {
      state.state_MonitoredArea_GetMyPageResult = rst
    },
    SET_MONITOREDAREA_BINDMONITOREDAREATOMONITOREDAREAGROUP_RESULT: (state, rst) => {
      state.state_MonitoredArea_BindmonitoredareaTomonitoredareaGroupResult = rst
    }
  },
  actions: {
    MonitoredAreaServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITOREDAREA_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITOREDAREA_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoredAreaServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITOREDAREA_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITOREDAREA_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoredAreaServ_SearchByName ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITOREDAREA_SEARCHBYNAME_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITOREDAREA_SEARCHBYNAME_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoredAreaServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITOREDAREA_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITOREDAREA_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoredAreaServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITOREDAREA_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITOREDAREA_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoredAreaServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITOREDAREA_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITOREDAREA_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoredAreaServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITOREDAREA_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITOREDAREA_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoredAreaServ_GetMyAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITOREDAREA_GETMYALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITOREDAREA_GETMYALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoredAreaServ_GetMyPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITOREDAREA_GETMYPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITOREDAREA_GETMYPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    MonitoredAreaServ_BindmonitoredareaTomonitoredareaGroup ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        bindmonitoredareaTomonitoredareaGroup(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_MONITOREDAREA_BINDMONITOREDAREATOMONITOREDAREAGROUP_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_MONITOREDAREA_BINDMONITOREDAREATOMONITOREDAREAGROUP_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_MonitoredArea_AddObjResult: state => {
      return state.state_MonitoredArea_AddObjResult
    },
    get_MonitoredArea_GetAllResult: state => {
      return state.state_MonitoredArea_GetAllResult
    },
    get_MonitoredArea_SearchByNameResult: state => {
      return state.state_MonitoredArea_SearchByNameResult
    },
    get_MonitoredArea_GetPageResult: state => {
      return state.state_MonitoredArea_GetPageResult
    },
    get_MonitoredArea_GetDetailResult: state => {
      return state.state_MonitoredArea_GetDetailResult
    },
    get_MonitoredArea_ModifyObjResult: state => {
      return state.state_MonitoredArea_ModifyObjResult
    },
    get_MonitoredArea_DeleteObjResult: state => {
      return state.state_MonitoredArea_DeleteObjResult
    },
    get_MonitoredArea_GetMyAllResult: state => {
      return state.state_MonitoredArea_GetMyAllResult
    },
    get_MonitoredArea_GetMyPageResult: state => {
      return state.state_MonitoredArea_GetMyPageResult
    },
    get_MonitoredArea_BindmonitoredareaTomonitoredareaGroupResult: state => {
      return state.state_MonitoredArea_BindmonitoredareaTomonitoredareaGroupResult
    }
  }
}
